"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = setSendTimeout;
exports.SET_SEND_TIMEOUT = void 0;
var SET_SEND_TIMEOUT = 'WEB_CHAT/SET_SEND_TIMEOUT';
exports.SET_SEND_TIMEOUT = SET_SEND_TIMEOUT;

function setSendTimeout(sendTimeout) {
  return {
    type: SET_SEND_TIMEOUT,
    payload: {
      sendTimeout: sendTimeout
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NldFNlbmRUaW1lb3V0LmpzIl0sIm5hbWVzIjpbIlNFVF9TRU5EX1RJTUVPVVQiLCJzZXRTZW5kVGltZW91dCIsInNlbmRUaW1lb3V0IiwidHlwZSIsInBheWxvYWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxnQkFBZ0IsR0FBRywyQkFBekI7OztBQUVlLFNBQVNDLGNBQVQsQ0FBd0JDLFdBQXhCLEVBQXFDO0FBQ2xELFNBQU87QUFDTEMsSUFBQUEsSUFBSSxFQUFFSCxnQkFERDtBQUVMSSxJQUFBQSxPQUFPLEVBQUU7QUFBRUYsTUFBQUEsV0FBVyxFQUFYQTtBQUFGO0FBRkosR0FBUDtBQUlEIiwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VUX1NFTkRfVElNRU9VVCA9ICdXRUJfQ0hBVC9TRVRfU0VORF9USU1FT1VUJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2V0U2VuZFRpbWVvdXQoc2VuZFRpbWVvdXQpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRVRfU0VORF9USU1FT1VULFxuICAgIHBheWxvYWQ6IHsgc2VuZFRpbWVvdXQgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRVRfU0VORF9USU1FT1VUIH07XG4iXX0=